module.exports = __webpack_public_path__ + "img/4_.b1ef0c1a.jpg";